<div class="reservation-navette">
	<p-toolbar styleClass="toolbar-reservation-navette">
		<div class="section-selecteur-filtrage">
			<app-selecteur-periode (changerPeriode)="changerPeriode($event)"
			                       [mode]="estAffichageMobile() ? MODE_SELECTEUR_PERIODE.JOUR : MODE_SELECTEUR_PERIODE.SEMAINE"
			                       [peutNaviguerDansPasse]="false">
			</app-selecteur-periode>
			@if (estAffichageMobile()) {
				<div class="boutons-filtrage">
					<p-button [icon]="sontFiltresActifs() ? 'pi pi-filter-fill' : 'pi pi-filter'"
					          class="btn-filtres-mobile"
					          label="{{ 'GLOBAL.FILTRER' | translate }}"
					          (click)="sidebarFiltresMobileVisible.set(true)">
					</p-button>

					@if (sontFiltresActifs()) {
						<p-button icon="pi pi-times"
						          (onClick)="reinitialiserFiltres()">
						</p-button>
					}
				</div>

				<p-sidebar [(visible)]="sidebarFiltresMobileVisible"
				           (onHide)="appliquerFiltres()"
				           position="bottom"
				           styleClass="sidebar-filtres">
					<ng-template pTemplate="header">
						<div class="filtrage-header"></div>
					</ng-template>
					<ng-container *ngTemplateOutlet="filtresTemplate"></ng-container>
				</p-sidebar>
			}
		</div>
		@if (!estAffichageMobile()) {
			<p-divider layout="vertical"></p-divider>
			<ng-container *ngTemplateOutlet="filtresTemplate"></ng-container>
		}
	</p-toolbar>
	<alert class="alerte-trajets" [nom]="NOM_ALERTE_TRAJETS"></alert>
	<app-affichage-liste-trajets [trajets]="trajetsFiltres()"
	                             [enChargement]="enChargement()"
	                             [delaiLimiteReservationApresDepart]="delaiLimiteReservation()"
	                             [messageAucunTrajet]="messageAucunTrajet()"
	                             [modeAffichage]="MODE_NAVETTE.RESERVATION"
	                             (rafraichirListe)="recupererTrajets()">
	</app-affichage-liste-trajets>
	<app-detail-reservation-trajet-dialog></app-detail-reservation-trajet-dialog>
</div>

<confirmation-modal-component></confirmation-modal-component>

<!-- Template partagé des filtres -->
<ng-template #filtresTemplate>
	<form class="filtrage-reservation" [formGroup]="filtresForm" (ngSubmit)="appliquerFiltres()">
		<div class="section-formulaire-reservation-navette">
			<div class="switch-input">
				<p-inputSwitch formControlName="afficherTrajetsDisponibles"></p-inputSwitch>
				<label for="afficherTrajetsDisponibles">{{ 'RESERVATION_NAVETTE.FILTRAGE.AFFICHER_TRAJETS_DISPONIBLES' | translate }}</label>
			</div>
			<div class="switch-input">
				<p-inputSwitch formControlName="afficherReservations"></p-inputSwitch>
				<label for="afficherReservations">{{ 'RESERVATION_NAVETTE.FILTRAGE.AFFICHER_RESERVATIONS' | translate }}</label>
			</div>
		</div>
		<p-divider layout="vertical"></p-divider>
		<div class="section-formulaire-reservation-navette">
			<div class="input-label">
				<label for="lieuDepart">{{ 'GESTION_NAVETTE.LIEU_DEPART' | translate }}</label>
				<app-lieux-autocomplete formControlName="lieuxDepart"
				                        [suggestions]="suggestionsLieuxAutocomplete()"/>
			</div>
			<div class="input-label">
				<label for="lieuArrivee">{{ 'GESTION_NAVETTE.LIEU_ARRIVEE' | translate }}</label>
				<app-lieux-autocomplete formControlName="lieuxArrivee"
				                        [suggestions]="suggestionsLieuxAutocomplete()"/>
			</div>
		</div>
		<p-divider layout="vertical"></p-divider>
		<div class="section-formulaire-reservation-navette">
			<div class="input-label">
				<label for="heureDepart">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.HEURE_DEPART' | translate }}</label>
				<p-calendar formControlName="heureDepart"
				            [timeOnly]="true"
				            [showIcon]="true"
				            iconDisplay="input">
					<ng-template pTemplate="inputicon">
						<i class="pi pi-clock"></i>
					</ng-template>
				</p-calendar>
			</div>
			<div class="input-label">
				<label for="heureArrivee">{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.HEURE_ARRIVEE' | translate }}</label>
				<p-calendar formControlName="heureArrivee"
				            [timeOnly]="true"
				            [showIcon]="true"
				            iconDisplay="input">
					<ng-template pTemplate="inputicon">
						<i class="pi pi-clock"></i>
					</ng-template>
				</p-calendar>
			</div>
		</div>
		<p-divider layout="vertical"></p-divider>
		<div class="section-formulaire-reservation-navette">
			<div class="boutons">
				<p-button type="button"
				          (onClick)="reinitialiserFiltres()"
				          styleClass="p-button-link"
				          label="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.BTN_REINITIALISER' | translate }}"/>
				<p-button type="submit"
				          label="{{ 'GESTION_NAVETTE.TRAJETS.FILTRAGE.BTN_APPLIQUER' | translate }}"/>
			</div>
		</div>
	</form>
</ng-template>
